import React, { useState } from 'react';
import { Input } from 'antd';
import { InputProps } from 'antd/lib/input';

interface NumericInputProps extends Omit<InputProps, 'onChange'> {
  value?: number;
  onChange?: (value: number) => void;
}
const NumericInput: React.FC<NumericInputProps> = ({ value, onChange, ...props}) => {
  const [strValue, setStrValue] = useState<string>('');
  const numRegex = /^\d+\.?\d?\d?$/;

  React.useEffect(() => {
    const strNum = value ? String(value) : '';
    setStrValue(strNum);
  }, [value]);

  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.value;
    if (value === '' || numRegex.test(value)) {
      setStrValue(value);
      onChange && onChange(Number(value));
    }
  };

  return (
    <Input type="text" {...props} value={strValue} onChange={handleChange} />
  );
};

export default NumericInput;
